import React, { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { useNavigate, useSearchParams } from 'react-router-dom';

// api
import ProjectService from '../../service/project-service';

// tools
import handleSuccessAndDisplay from '../../helpers/handleSuccessAndDisplay';
import handleErrorAndDisplay from '../../helpers/handleErrorAndDisplay';

// components
import LogoIcon from '../../icons/LogoIcon';
import ButtonFlat from '../../components/ButtonWrapper/components/ButtonFlat';

const AcceptInvitation = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [loading, setLoading] = useState(true);
    const [accepted, setAccepted] = useState(false);

    useEffect(() => {
        if (!token) {
            handleErrorAndDisplay(__('Token non valido.', 'soundbetween'));
            setLoading(false);
            return;
        }
        ProjectService.createProjectTeamInvitationAcceptAsync({ token })
            .then(() => {
                handleSuccessAndDisplay(__('Invito accettato con successo!', 'soundbetween'));
                setAccepted(true);
            })
            .catch(() => {
                handleErrorAndDisplay(__('Errore durante l\'accettazione dell\'invito.', 'soundbetween'));
            })
            .finally(() => setLoading(false));
    }, [token]);

    const handleGoToLogin = () => {
        navigate('/login');
    };

    return (
        <div className={['appPage', 'appPageLogin'].join(' ')}>
            <div className="appPageLogin__wrapper">

                <LogoIcon/>

                <div className="loginCard">
                    {loading && (
                        <span className="loginCard__subttitle">{__('Caricamento...', 'soundbetween')}</span>
                    )}

                    {!loading && accepted && (
                        <>
                            <span className="loginCard__title">{__('Invitazione accettato', 'soundbetween')}</span>
                            <span className="loginCard__subttitle">
                                {__('Grazie per aver accettato l\u2019invito di connessione! Clicca il bottone qui sotto per loggarti.', 'soundbetween')}
                            </span>
                            <ButtonFlat onClick={handleGoToLogin}>{__('Vai alla login')}</ButtonFlat>
                        </>
                    )}

                    {!loading && !accepted && (
                        <>
                            <span className="loginCard__title">{__('Errore', 'soundbetween')}</span>
                            <span className="loginCard__subttitle">
                                {__('Non è stato possibile accettare l\u2019invito. Il token potrebbe essere non valido o scaduto.', 'soundbetween')}
                            </span>
                            <ButtonFlat onClick={handleGoToLogin}>{__('Vai alla login')}</ButtonFlat>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AcceptInvitation;
